import { render } from "./CompleteWebsite.vue?vue&type=template&id=28cdaad1"
import script from "./CompleteWebsite.vue?vue&type=script&lang=js"
export * from "./CompleteWebsite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__